var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.166 10.833h2.5m-5-3.333 1.667.833 1.059-3.177c.218-.655.327-.983.53-1.226.18-.214.409-.38.669-.481.294-.116.64-.116 1.33-.116h6.156c.691 0 1.037 0 1.331.116.26.102.49.267.669.481.202.243.312.57.53 1.226l1.059 3.177 1.667-.833m-5 3.333h2.5m-10.167-2.5h8.667c1.4 0 2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092c.273.535.273 1.235.273 2.635v2.25c0 .387 0 .58-.032.742a1.67 1.67 0 0 1-1.31 1.31c-.16.031-.354.031-.742.031h-.416c-.92 0-1.667-.746-1.667-1.666a.417.417 0 0 0-.417-.417h-7.5a.417.417 0 0 0-.416.417c0 .92-.747 1.666-1.667 1.666h-.417c-.387 0-.58 0-.741-.032a1.67 1.67 0 0 1-1.31-1.31c-.032-.16-.032-.354-.032-.741v-2.25c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.092c.535-.273 1.235-.273 2.635-.273"
  })));
};
export default SvgCar;